import { forkJoin, Observable } from "rxjs";
import { map } from "rxjs/operators";

import * as http from "../../../../../../../../../services/http.service";
import { SearchResults } from "../../../../../../../../../types/search/search-results.interface";
import { Nullable } from "../../../../../../../../../types/common";
import { IAsset } from "../../../../../../../../../features/file-attachments/types/file-attachment.interface";

import { FlyerPageUploadAssetResponse } from "../types/flyer-detail-page-assets.interface";

const endpoint = (pageId: number) => `/pages/${pageId}/attachments/`;

export function fetchAssets(pageId: number): Observable<IAsset[]> {
  return http.get<SearchResults<FlyerPageUploadAssetResponse>>(endpoint(pageId)).pipe(
    map((response) => response.results),
    map(mapFlyerPageUploadAssetResponsesToFlyerPageAssets)
  );
}

export function uploadAssets(assets: File[], pageId: number): Observable<IAsset[]> {
  return forkJoin(assets.map((asset) => doUploadAsset(asset, pageId)));
}

function doUploadAsset(asset: File, pageId: number): Observable<IAsset> {
  const formData = new FormData();
  formData.set("attachment", asset);
  formData.set("is_asset", "1");
  formData.set("page", `${pageId}`);

  return http
    .post<FlyerPageUploadAssetResponse>(endpoint(pageId), formData)
    .pipe(map(mapFlyerPageUploadAssetResponseToFlyerPageAssets));
}

const mapFlyerPageUploadAssetResponsesToFlyerPageAssets = (
  responses: FlyerPageUploadAssetResponse[]
): IAsset[] => responses.map(mapFlyerPageUploadAssetResponseToFlyerPageAssets);

const mapFlyerPageUploadAssetResponseToFlyerPageAssets = (
  response: FlyerPageUploadAssetResponse
): IAsset => {
  return {
    id: response.id,
    createdAt: response.createdAt,
    url: response.attachment,
    description: response.description,
    mimetype: response.mimetype,
    owner: response.ownerDetails,
    size: response.size,
  };
};

export const addAssetsToAssets = (newAssets: IAsset[], currentAssets: Nullable<IAsset[]>) =>
  (currentAssets || []).concat(newAssets);
